/* Urun karti etkilesimleri. NOT: Shopify snippet'lerdeki {% javascript %}
   bloklarini derlemedigi icin bu kod ayri bir asset olarak layout'ta yuklenir.
   Delegasyon kullanildigi icin sonsuz kaydirma / AJAX ile eklenen kartlarda
   da otomatik calisir. */
(function () {
  // --- Kart rozeti: KESINTISIZ LED marquee ---
  // Icerik (bir set rozet) kart genisligini dolduracak kadar cogaltilir, sonra
  // iki ozdes yarim olusturulur; translateX(-50%) tam bir yarimi kaydirir ->
  // dongu basa donunca "pat" olmaz, akici devam eder. Hiz: bir kart genisligini
  // 'speed' saniyede gececek sekilde ayarlanir (icerikten bagimsiz tutarli hiz).
  var setup = function (m) {
    if (!m || m.dataset.marqueeDone === '1') return;
    var box = m.parentElement;
    var cw = (box && box.clientWidth) || 0;
    if (!cw) return; // henuz olculemiyor (gizli); sonra tekrar denenir
    if (m.__unit == null) m.__unit = m.innerHTML; // orijinal set (yalniz bir kez saklanir)
    var unit = m.__unit;
    if (!unit || !unit.trim()) return;
    // Bir yarim: kart genisligini asana kadar seti tekrarla.
    m.innerHTML = unit;
    var guard = 0;
    while (m.scrollWidth < cw && guard < 40) { m.insertAdjacentHTML('beforeend', unit); guard++; }
    var halfW = m.scrollWidth;
    m.innerHTML = m.innerHTML + m.innerHTML; // iki ozdes yarim -> kusursuz dongu
    var speed = parseFloat(m.dataset.marqueeSpeed) || 8; // 1 kart genisligi kac sn'de gecsin
    var pxPerSec = cw / speed;
    m.style.animationDuration = (halfW / pxPerSec) + 's';
    m.classList.add('is-marquee-ready');
    m.dataset.marqueeDone = '1';
  };
  var scan = function () { document.querySelectorAll('[data-marquee]:not([data-marquee-done="1"])').forEach(setup); };
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  // Gec yuklenen / AJAX (sonsuz kaydirma) kartlar + ilk anda olculemeyenler icin.
  window.addEventListener('load', scan);
  if ('MutationObserver' in window) {
    new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('resize', function () {
    // Genislik degisince yeniden kur (yeniden olcum icin done bayragini sifirla).
    document.querySelectorAll('[data-marquee]').forEach(function (m) { m.dataset.marqueeDone = ''; });
    scan();
  });
})();

(function () {
  // --- Kart gorsel slider'i ---
  // MOBIL: native yatay scroll (scroll-snap) -> lazy gorseller kaydirinca
  //   guvenilir yuklenir. MASAUSTU: transform (fare ile bolgesel gezinme).
  var isDesktop = function () { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; };
  var currentIndex = function (track) {
    if (isDesktop()) return parseInt(track.dataset.i || '0', 10);
    return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  };
  var setBars = function (slider, i) {
    slider.querySelectorAll('.card__bar').forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
  };

  // Gorselleri yukleme guvencesi: lazy olanlari eager yap (transform/hover'da
  // gorunmezken de yuklensinler), yuklenince goster.
  var markLoaded = function (img) {
    img.classList.add('is-loaded');
    var m = img.closest('.card__media'); if (m) m.classList.add('is-loaded');
  };
  var forceLoad = function (slider) {
    if (slider.dataset.imgsForced) return;
    slider.dataset.imgsForced = '1';
    slider.querySelectorAll('.card__img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
      img.addEventListener('load', function () { markLoaded(img); }, { once: true });
      img.addEventListener('error', function () { markLoaded(img); }, { once: true });
      img.removeAttribute('loading');
    });
  };

  var showImage = function (slider, track, k) {
    var n = Math.max(0, Math.min(track.children.length - 1, k));
    if (isDesktop()) {
      track.dataset.i = n;
      // Gorseller 1px fazla genis (dikis cizgisi fix); transform de n*1px kaydirir.
      track.style.transform = 'translateX(calc(-' + (n * 100) + '% - ' + n + 'px))';
    } else {
      track.scrollTo({ left: n * track.clientWidth, behavior: 'auto' });
    }
    setBars(slider, n);
  };

  // Masaustu: fareyi saga-sola gezdirince gorsel degisir (bolgelere gore).
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var slider = e.target.closest && e.target.closest('[data-card-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-card-track]');
    if (!track || track.children.length < 2) return;
    if (!slider.dataset.hoverInit) {
      slider.dataset.hoverInit = '1';
      forceLoad(slider); // masaustu: hover baslayinca gorselleri yukle
      slider.addEventListener('mouseleave', function () { showImage(slider, track, 0); });
    }
    var rect = slider.getBoundingClientRect();
    var ratio = (e.clientX - rect.left) / Math.max(1, rect.width);
    var k = Math.max(0, Math.min(track.children.length - 1, Math.floor(ratio * track.children.length)));
    if (currentIndex(track) !== k) showImage(slider, track, k);
  });

  // Mobil: parmak degince gorselleri yukle (native scroll zaten yukler; garanti).
  document.addEventListener('touchstart', function (e) {
    var slider = e.target.closest && e.target.closest('[data-card-slider]');
    if (slider) forceLoad(slider);
  }, { passive: true });

  // Mobil: parmakla kaydirinca aktif cubugu guncelle (scroll capture ile).
  var raf;
  document.addEventListener('scroll', function (e) {
    var track = e.target.closest && e.target.closest('[data-card-track]');
    if (!track) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      setBars(track.closest('[data-card-slider]'), Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
    });
  }, true);

  // Slider viewport'a yaklasinca gorselleri onceden yukle (mobil + masaustu).
  var imgIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { forceLoad(en.target); imgIO.unobserve(en.target); }
        });
      }, { rootMargin: '600px' })
    : null;
  var observeSlider = function (slider) {
    if (!slider.querySelector('[data-card-track]')) return;
    if (imgIO) imgIO.observe(slider); else forceLoad(slider);
  };

  // Ilk durum: masaustu transform baslangici + aktif cubuk + gozlem.
  var initAll = function () {
    document.querySelectorAll('[data-card-slider]').forEach(function (slider) {
      observeSlider(slider);
      var track = slider.querySelector('[data-card-track]');
      if (!track || track.children.length < 2) return;
      showImage(slider, track, currentIndex(track));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // AJAX ile eklenen kartlar (sonsuz kaydirma / filtre) icin de gozlemle.
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-card-slider]')) observeSlider(n);
          if (n.querySelectorAll) n.querySelectorAll('[data-card-slider]').forEach(observeSlider);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

(function () {
  // Hizli sepete ekle (kart gorseli sag alti). Tek varyantli urunlerde calisir;
  // cok varyantlilar zaten <a> ile urun sayfasina gider. Delegasyon -> AJAX kartlar da.
  var setCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (el.classList.contains('mnav__count')) { el.textContent = n; el.setAttribute('data-cart-count', n); }
      else { el.textContent = '(' + n + ')'; }
    });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // Ilave harf ucreti satirlari (ana urunun alt kalemi) sayimda haric.
        var rc = (cart.items || []).reduce(function (s, i) { return (('' + (i.handle || '')).indexOf('harf-ucreti') !== -1) ? s : s + i.quantity; }, 0);
        setCount(rc);
        window.dispatchEvent(new CustomEvent('akik:cart-updated', { detail: cart }));
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });
})();
